import routes from "../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut} from "../../../../core/services/common/HttpRequestBuilder";


const getDriverList = (parameters) => {
    // let parameters = null;
    let result = HttpAuthGet(routes.GET_DRIVER_LIST, parameters);
    return result;
}

const getDriverListByVehicleUID = (parameters) => {
    let result = HttpAuthGet(routes.GET_DRIVER_LIST_BY_VEHICLE_UID, parameters);
    return result;
}

const getOrganizationDriverList  = (parameters) => {
    let result = HttpAuthGet(routes.GET_ORGANIZATION_DRIVER_LIST, parameters);
    return result;
}

const getViewDriver = (parameters) => {
    let result = HttpAuthGet(routes.GET_VIEW_DRIVER, parameters);
    return result;
}

const createDriver = (payload) => {
    let result = HttpAuthPost(routes.CREATE_BUSINESS_DRIVER, payload);
    return result;
}

const businessViewDriver = (parameters) => {
    let result = HttpAuthGet(routes.VIEW_DRIVER_LIST, parameters);
    return result;
}

const updateDriverStatus = (parameters) => {
    let result = HttpAuthPut(routes.UPDATE_RIVER_STATUS, parameters);
    return result;
}

const listDriverFilter = (parameters) => {
    let result = HttpAuthGet(routes.LIST_DRIVER_FILTER, parameters);
    return result;
}


const DriverService = {
    getViewDriver: getViewDriver,
    getDriverList: getDriverList,
    getDriverListByVehicleUID,
    createDriver: createDriver,
    businessViewDriver: businessViewDriver,
    updateDriverStatus: updateDriverStatus,

    // organization drivers
    getOrganizationDriverList: getOrganizationDriverList,

    listDriverFilter: listDriverFilter,
}

export default DriverService